import { render, staticRenderFns } from "./PostSkillsCompetition.vue?vue&type=template&id=f0751a78&scoped=true&"
import script from "./PostSkillsCompetition.vue?vue&type=script&lang=js&"
export * from "./PostSkillsCompetition.vue?vue&type=script&lang=js&"
import style0 from "./PostSkillsCompetition.vue?vue&type=style&index=0&id=f0751a78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0751a78",
  null
  
)

export default component.exports